// src/utils/auth.js
import api from "../axiosConfig";

export function hardLogout({
  redirectTo = "/login",
  preserveKeys = ["app.lang", "app.notifications"],
} = {}) {
  const preserved = {};

  for (const key of preserveKeys) {
    try {
      preserved[key] = localStorage.getItem(key);
    } catch {}
  }

  try {
    localStorage.clear();
  } catch {}

  try {
    sessionStorage.clear();
  } catch {}

  for (const [key, value] of Object.entries(preserved)) {
    if (value == null) continue;

    try {
      localStorage.setItem(key, value);
    } catch {}
  }

  try {
    delete api.defaults.headers.common.Authorization;
  } catch {}

  if ("caches" in window) {
    caches
      .keys()
      .then((keys) => keys.forEach((key) => caches.delete(key)))
      .catch(() => {});
  }

  window.location.assign(redirectTo);
}